import { FooterModalButtons } from "@/controls/buttons/FooterModalButtons";
import {
	CATALOG_GRADE_INITIAL_VALUES,
	CatalogGrade,
} from "@/pages/steel/models/CatalogGrade";
import { copyChemistriesLimit } from "@/pages/steel/repositories/CatalogGradeRepository";
import { GradeSelector } from "@/shared/GradeSelector";
import { MesfModal } from "@dexteel/mesf-core";
import { Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

type Props = {
	gradeId: number;
	show: boolean;
	onHide: (id?: number | null) => void;
	setError: (error: string) => void;
	setNotificationMessage: (message: string) => void;
};

export const CopyFromModal = ({
	gradeId,
	show,
	onHide,
	setError,
	setNotificationMessage,
}: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false);
	const navigate = useNavigate();
	const { control, handleSubmit } = useForm<CatalogGrade>({
		mode: "onChange",
		defaultValues: CATALOG_GRADE_INITIAL_VALUES,
	});

	const onSubmit: SubmitHandler<CatalogGrade> = async (data) => {
		setIsSubmitLoading(true);
		const copyResponse = await copyChemistriesLimit({
			source: data.GradeId!,
			target: gradeId,
		});
		if (copyResponse.ok) {
			setNotificationMessage("The chemistry limits were succesfully copied.");
			onHide(data.GradeId);
			navigate(`/configuration/steel-grade/${gradeId}`);
		} else {
			setError(copyResponse.message);
		}
		setIsSubmitLoading(false);
	};

	return (
		<>
			<MesfModal
				title={`COPY CHEMISTRIES LIMITS`}
				open={show}
				handleClose={() => onHide()}
				maxWidth="sm"
				id="ladle-modal"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<MesfModal.Content dividers style={{ padding: "20px 30px" }}>
						<Grid container style={{ display: "flex", alignItems: "center" }}>
							<Grid item xs={5}>
								<Typography variant="h6">Copy from Grade: </Typography>
							</Grid>
							<Grid item xs={7}>
								<Controller
									name="GradeId"
									control={control}
									rules={{ required: "You have to select a grade" }}
									render={({ field: { onChange, value }, fieldState }) => (
										<GradeSelector
											label="Grade"
											value={value}
											fieldError={fieldState.error}
											onChange={onChange}
										/>
									)}
								/>
							</Grid>
						</Grid>
					</MesfModal.Content>
					<MesfModal.Actions style={{ padding: "20px 30px 20px" }}>
						<FooterModalButtons
							isSubmitLoading={false}
							onHide={() => onHide()}
						/>
					</MesfModal.Actions>
				</form>
			</MesfModal>
		</>
	);
};
